<div [ngSwitch]="data.message" class="elohn-snackbar">
    <ng-container *ngSwitchCase="SnackbarMessage.CLEAR_ALL_CONFIRMATION"
                  i18n="@@SnackbarMessage.CLEAR_ALL_CONFIRMATION">Alle Daten gelöscht
    </ng-container>
    <ng-container *ngSwitchCase="SnackbarMessage.IMPORT_SUCCESS"
                  i18n="@@SnackbarMessage.SUCCESS">Datei {{ data.fileName }} erfolgreich importiert
    </ng-container>
    <ng-container *ngSwitchCase="SnackbarMessage.IMPORT_CANCELLATION"
                  i18n="@@SnackbarMessage.CANCEL">Das Einlesen der Datei wurde abgebrochen
    </ng-container>
    <ng-container *ngSwitchCase="SnackbarMessage.IMPORT_ERROR"
                  i18n="@@SnackbarMessage.ERROR">Beim Einlesen der Datei ist ein Fehler aufgetreten. {{ data.details }}
    </ng-container>
    <ng-container *ngSwitchCase="SnackbarMessage.IMPORT_WRONG_EXTENSION"
                  i18n="@@SnackbarMessage.WRONG_EXTENSION">Das Einlesen der Datei {{ data.fileName }} ist nicht möglich. Nicht unterstütztes Dateiformat *.{{ data.details }}
    </ng-container>
</div>
